// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/QanelasRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/QanelasMedium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/QanelasSemiBold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Qanelas';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: 'Qanelas';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: 500;
  font-display: swap;
}
@font-face {
  font-family: 'Qanelas';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: 600;
  font-display: swap;
}
.provider-details {
  font:
    400 14px/20px 'Qanelas',
    Arial,
    sans-serif;
  color: #202124;
  letter-spacing: 0;
}
.provider-details * {
  box-sizing: border-box;
}
.provider-details button,
.provider-details a {
  font-family: inherit;
  letter-spacing: 0;
}
.provider-details h2 {
  margin: 0;
  font:
    600 22px/28px 'Qanelas',
    Arial,
    sans-serif;
  color: #003087;
  overflow-wrap: anywhere;
}
.provider-details .details-scroll {
  width: 100%;
  max-height: calc(100vh - 152px);
  overflow-y: auto;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  overscroll-behavior: contain;
}
.provider-details .details-scroll > * {
  flex-shrink: 0;
}
.provider-details .details-portrait {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}
.provider-details .details-scroll::-webkit-scrollbar {
  width: 6px;
}
.provider-details .details-scroll::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}
.provider-details .details-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
}
.provider-details .details-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.provider-details .details-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  color: #003087;
}
.provider-details .details-icon svg {
  display: block;
}
.provider-details .details-tier {
  min-height: 25px;
  border-radius: 24px;
  background: #fbd07c;
  color: #000;
  padding: 4px 8px;
  line-height: 17px;
}
.provider-details .details-bio {
  align-self: stretch;
  white-space: pre-line;
  overflow-wrap: anywhere;
}
.provider-details .details-location {
  border-top: 1px solid #d9d9d9;
  padding: 16px 0;
  display: flex;
  gap: 16px;
}
.provider-details .details-location-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}
.provider-details .details-location-header {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
}
.provider-details .details-location-name {
  color: #003087;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.provider-details .details-qa {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
}
.provider-details .details-qa-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.provider-details .details-qa-row strong {
  font-weight: 600;
}
.provider-details .details-plans {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 8px;
}
.provider-details .details-plans strong {
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  margin-bottom: 2px;
}
.provider-details .details-office-hours,
.provider-details .details-accessibility {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 8px;
}
.provider-details .details-office-hours strong,
.provider-details .details-accessibility strong {
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  margin-bottom: 2px;
}
.provider-details .details-correct {
  align-self: stretch;
  border-top: 1px solid #d9d9d9;
  padding-top: 16px;
  color: #666;
}
.mobile-provider-details .details-scroll {
  height: 100%;
  max-height: none;
  padding: 16px 20px max(32px, env(safe-area-inset-bottom));
  gap: 16px;
}
.mobile-provider-details .details-portrait {
  gap: 16px;
}
.mobile-provider-details .details-location-header {
  flex-wrap: wrap;
}
.mobile-provider-details .details-location {
  border-top: 0;
  padding: 0 0 16px;
}
.details-location-link {
  font: inherit;
  border: 0;
  padding: 0;
  background: none;
  text-align: left;
  cursor: pointer;
}
.mobile-location-details {
  height: var(--mobile-sheet-height);
  overflow-y: auto;
  background: #fff;
  padding-bottom: env(safe-area-inset-bottom);
}
.mobile-location-body {
  padding: 16px 20px 32px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
}
.mobile-location-details a {
  color: inherit;
  text-decoration: none;
}
.mobile-stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  overflow-wrap: anywhere;
}
.mobile-name {
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  color: #003087;
}
.mobile-result {
  padding: 16px 20px 20px;
  border: 1px solid #d9d9d9;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #fff;
  cursor: pointer;
}
.mobile-provider-result {
  background: #f6eef9;
  padding: 20px;
}
.mobile-result-heading,
.mobile-provider-link {
  display: flex;
  gap: 16px;
  align-items: center;
  text-align: left;
  border: 0;
  background: none;
  padding: 0;
  color: inherit;
  font: inherit;
  width: 100%;
  cursor: pointer;
}
.mobile-provider-link {
  padding: 16px 20px;
  border-bottom: 1px solid #d9d9d9;
}
.mobile-avatar-row {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}
.mobile-results-header {
  height: 76px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 8px;
  gap: 4px;
  color: #666;
}
.mobile-results-header > span {
  height: 32px;
  display: flex;
  align-items: center;
}
.correction-dialog {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.correction-dialog .correction-title {
  padding-right: 40px;
}
.correction-dialog p {
  margin: 0;
}
.correction-role {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;
  text-align: left;
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.correction-role:hover {
  background: #f4edf5;
  box-shadow: 0 1px 3px rgba(44, 42, 41, 0.12);
}
.correction-role strong {
  color: #003087;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
}
.correction-role span {
  color: #666;
}
.correction-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.correction-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.correction-field label {
  color: #003087;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  text-transform: uppercase;
}
.correction-field input,
.correction-field textarea {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px 12px;
  background: #fff;
  font:
    400 14px/20px 'Qanelas',
    Arial,
    sans-serif;
  color: #000;
  width: 100%;
}
.correction-field input:focus,
.correction-field textarea:focus {
  outline: 2px solid #0095c8;
  outline-offset: 2px;
  border-color: #0095c8;
}
.correction-field textarea {
  min-height: 96px;
  resize: vertical;
}
.correction-submit {
  height: 44px;
  flex: none;
  border: 0;
  border-radius: 24px;
  background: #8c4799;
  color: #fff;
  font:
    500 14px/20px 'Qanelas',
    Arial,
    sans-serif;
  text-transform: uppercase;
  cursor: pointer;
}
.correction-submit:hover {
  background: #7d3f89;
}
.correction-back {
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: none;
  color: #003087;
  text-decoration: underline;
  font: inherit;
  font-weight: 500;
  cursor: pointer;
}
.correction-error {
  color: #b3261e;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProviderDetailsPanel.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,+DAAiE;EACjE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;;;cAGY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT;;;cAGY;EACZ,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,yDAAyD;EACzD,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;;EAEE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,aAAa;EACb,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;;cAGY;EACZ,WAAW;EACX,WAAW;AACb;AACA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX;;;cAGY;EACZ,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB","sourcesContent":["@font-face {\n  font-family: 'Qanelas';\n  src: url('../assets/fonts/QanelasRegular.otf') format('opentype');\n  font-weight: 400;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Qanelas';\n  src: url('../assets/fonts/QanelasMedium.otf') format('opentype');\n  font-weight: 500;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Qanelas';\n  src: url('../assets/fonts/QanelasSemiBold.otf') format('opentype');\n  font-weight: 600;\n  font-display: swap;\n}\n.provider-details {\n  font:\n    400 14px/20px 'Qanelas',\n    Arial,\n    sans-serif;\n  color: #202124;\n  letter-spacing: 0;\n}\n.provider-details * {\n  box-sizing: border-box;\n}\n.provider-details button,\n.provider-details a {\n  font-family: inherit;\n  letter-spacing: 0;\n}\n.provider-details h2 {\n  margin: 0;\n  font:\n    600 22px/28px 'Qanelas',\n    Arial,\n    sans-serif;\n  color: #003087;\n  overflow-wrap: anywhere;\n}\n.provider-details .details-scroll {\n  width: 100%;\n  max-height: calc(100vh - 152px);\n  overflow-y: auto;\n  padding: 16px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  align-items: center;\n  overscroll-behavior: contain;\n}\n.provider-details .details-scroll > * {\n  flex-shrink: 0;\n}\n.provider-details .details-portrait {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n}\n.provider-details .details-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n.provider-details .details-scroll::-webkit-scrollbar-thumb {\n  background: #d9d9d9;\n  border-radius: 3px;\n}\n.provider-details .details-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-self: stretch;\n}\n.provider-details .details-row {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n.provider-details .details-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  color: #003087;\n}\n.provider-details .details-icon svg {\n  display: block;\n}\n.provider-details .details-tier {\n  min-height: 25px;\n  border-radius: 24px;\n  background: #fbd07c;\n  color: #000;\n  padding: 4px 8px;\n  line-height: 17px;\n}\n.provider-details .details-bio {\n  align-self: stretch;\n  white-space: pre-line;\n  overflow-wrap: anywhere;\n}\n.provider-details .details-location {\n  border-top: 1px solid #d9d9d9;\n  padding: 16px 0;\n  display: flex;\n  gap: 16px;\n}\n.provider-details .details-location-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n}\n.provider-details .details-location-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: space-between;\n}\n.provider-details .details-location-name {\n  color: #003087;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n.provider-details .details-qa {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 8px;\n}\n.provider-details .details-qa-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.provider-details .details-qa-row strong {\n  font-weight: 600;\n}\n.provider-details .details-plans {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 8px;\n}\n.provider-details .details-plans strong {\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n  margin-bottom: 2px;\n}\n.provider-details .details-office-hours,\n.provider-details .details-accessibility {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 8px;\n}\n.provider-details .details-office-hours strong,\n.provider-details .details-accessibility strong {\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n  margin-bottom: 2px;\n}\n.provider-details .details-correct {\n  align-self: stretch;\n  border-top: 1px solid #d9d9d9;\n  padding-top: 16px;\n  color: #666;\n}\n.mobile-provider-details .details-scroll {\n  height: 100%;\n  max-height: none;\n  padding: 16px 20px max(32px, env(safe-area-inset-bottom));\n  gap: 16px;\n}\n.mobile-provider-details .details-portrait {\n  gap: 16px;\n}\n.mobile-provider-details .details-location-header {\n  flex-wrap: wrap;\n}\n.mobile-provider-details .details-location {\n  border-top: 0;\n  padding: 0 0 16px;\n}\n.details-location-link {\n  font: inherit;\n  border: 0;\n  padding: 0;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n}\n.mobile-location-details {\n  height: var(--mobile-sheet-height);\n  overflow-y: auto;\n  background: #fff;\n  padding-bottom: env(safe-area-inset-bottom);\n}\n.mobile-location-body {\n  padding: 16px 20px 32px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 16px;\n}\n.mobile-location-details a {\n  color: inherit;\n  text-decoration: none;\n}\n.mobile-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.mobile-name {\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  color: #003087;\n}\n.mobile-result {\n  padding: 16px 20px 20px;\n  border: 1px solid #d9d9d9;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #fff;\n  cursor: pointer;\n}\n.mobile-provider-result {\n  background: #f6eef9;\n  padding: 20px;\n}\n.mobile-result-heading,\n.mobile-provider-link {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  text-align: left;\n  border: 0;\n  background: none;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  width: 100%;\n  cursor: pointer;\n}\n.mobile-provider-link {\n  padding: 16px 20px;\n  border-bottom: 1px solid #d9d9d9;\n}\n.mobile-avatar-row {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n.mobile-results-header {\n  height: 76px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 8px;\n  gap: 4px;\n  color: #666;\n}\n.mobile-results-header > span {\n  height: 32px;\n  display: flex;\n  align-items: center;\n}\n.correction-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.correction-dialog .correction-title {\n  padding-right: 40px;\n}\n.correction-dialog p {\n  margin: 0;\n}\n.correction-role {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 16px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  background: #fff;\n  text-align: left;\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n}\n.correction-role:hover {\n  background: #f4edf5;\n  box-shadow: 0 1px 3px rgba(44, 42, 41, 0.12);\n}\n.correction-role strong {\n  color: #003087;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n}\n.correction-role span {\n  color: #666;\n}\n.correction-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.correction-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.correction-field label {\n  color: #003087;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.correction-field input,\n.correction-field textarea {\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  padding: 10px 12px;\n  background: #fff;\n  font:\n    400 14px/20px 'Qanelas',\n    Arial,\n    sans-serif;\n  color: #000;\n  width: 100%;\n}\n.correction-field input:focus,\n.correction-field textarea:focus {\n  outline: 2px solid #0095c8;\n  outline-offset: 2px;\n  border-color: #0095c8;\n}\n.correction-field textarea {\n  min-height: 96px;\n  resize: vertical;\n}\n.correction-submit {\n  height: 44px;\n  flex: none;\n  border: 0;\n  border-radius: 24px;\n  background: #8c4799;\n  color: #fff;\n  font:\n    500 14px/20px 'Qanelas',\n    Arial,\n    sans-serif;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n.correction-submit:hover {\n  background: #7d3f89;\n}\n.correction-back {\n  align-self: flex-start;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: #003087;\n  text-decoration: underline;\n  font: inherit;\n  font-weight: 500;\n  cursor: pointer;\n}\n.correction-error {\n  color: #b3261e;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
